import { mdiLoading, mdiFilePdfBox } from '@mdi/js'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { IconButton } from '../IconButton'
import { Tooltip } from '../Tooltip'

export const ExportPdfButton: React.FC<{ isLoading: boolean; onClick: () => void }> = props => {
    const { t } = useTranslation('exportButtons')
    return (
        <Tooltip text={t('PDFExport')} className='cursor-pointer relative' onClick={props.onClick}>
            <IconButton
                isSubmit
                path={props.isLoading ? mdiLoading : mdiFilePdfBox}
                spin={props.isLoading}
                size={1}
                disabled={props.isLoading}
                className='rounded-2xl transition duration-500 bg-white p-2.5 shadow-md mx-0.5 cursor-pointer text-red-900 hover:bg-red-900 hover:text-white'
            ></IconButton>
        </Tooltip>
    )
}
